import pt from '../../locales/pt';
import { useTheme } from '../../store/ThemeContext';
import { cn } from '../../utils/cn';

const OPTIONS = [
  { value: 'light', label: pt.settings.appearance.options.light.title },
  { value: 'system', label: pt.settings.hub.themeAuto },
  { value: 'dark', label: pt.settings.appearance.options.dark.title },
];

export function ThemeSegmentControl({ className }) {
  const { theme, setTheme } = useTheme();

  return (
    <div
      className={cn(
        'flex shrink-0 gap-1 rounded-[10px] bg-muted p-0.5',
        className,
      )}
      role="group"
      aria-label={pt.settings.appearance.title}
    >
      {OPTIONS.map(({ value, label }) => {
        const selected = theme === value;
        return (
          <button
            key={value}
            type="button"
            onClick={() => setTheme(value)}
            className={cn(
              'rounded-lg px-2.5 py-1.5 text-[11px] font-semibold transition-colors',
              selected
                ? 'bg-card text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
            )}
            aria-pressed={selected}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
